<template>
  <div class="scheduler-page">
    <el-tabs v-model="activeTab" class="tabs">
      <el-tab-pane label="Текущие смены" name="current">
        <el-skeleton :loading="isLoading" animated>
          <template #default>
            <shift-table
              :type="activeTab"
              :users="schedules"
              :loading="isLoading"
              @update-shifts="onUpdateShifts"
              @delete-shifts="onDeleteShifts"
            />
          </template>
        </el-skeleton>
        <el-button
          type="primary"
          icon="el-icon-plus"
          class="create-shift-btn"
          @click="scheduleDialogVisible = true">Создать смену</el-button>
      </el-tab-pane>
      <el-tab-pane label="История смен" name="history">
        <el-skeleton :loading="isLoading" animated>
          <template #default>
            <shift-table
              :type="activeTab"
              :users="schedules"
              :loading="isLoading"
            />
          </template>
        </el-skeleton>
      </el-tab-pane>
      <el-tab-pane label="Шаблоны смен" name="templates">
        <shift-template-manager />
      </el-tab-pane>
    </el-tabs>

    <create-schedule-dialog
      v-model="scheduleDialogVisible"
    />
  </div>
</template>
<script>
import ShiftTable from '@/components/util/scheduler/ShiftTable.vue'
import CreateScheduleDialog from '@/components/util/scheduler/CreateScheduleDialog.vue'
import ShiftTemplateManager from '@/components/util/scheduler/ShiftTemplateManager.vue'
import { mapActions, mapState } from 'vuex'
import { ElMessage, ElMessageBox } from 'element-plus'

export default {
  name: 'SchedulerPage',
  components: {
    ShiftTable,
    CreateScheduleDialog,
    ShiftTemplateManager
  },
  data() {
    return {
      activeTab: 'current',
      scheduleDialogVisible: false,
      isLoading: false
    }
  },
  computed: {
    ...mapState('schedules', ['schedules'])
  },
  created() {
    this.isLoading = true;
    this.getUsers();
    this.getCities();
    this.loadSchedules();
  },
  watch: {
    activeTab() {
      this.loadSchedules();
    }
  },
  methods: {
    ...mapActions('schedules', ['fetchSchedules', 'updateSchedule', 'deleteSchedule']),
    ...mapActions('users', ['getUsers']),
    ...mapActions('cities', ['getCities']),
    async loadSchedules() {
      this.isLoading = true;
      await this.fetchSchedules({ type: this.activeTab });
      this.isLoading = false;
    },
    async onUpdateShifts(user) {
      try {
        const payload = {
          user_id: user.id,
          city_id: user.city_id,
          branch_id: user.branch_id,
          room_id: user.room_id,
          shifts: (user.shifts || []).map(shift => ({
            date: shift.date,
            start_time: shift.start_time,
            end_time: shift.end_time,
            breaks: Array.isArray(shift.breaks)
              ? shift.breaks.map(b => ({
                type: b.type,
                start: b.start || b.start_time,   // ← добавили fallback
                end: b.end || b.end_time,
                date: shift.date
              }))
              : []
          }))
        };

        console.log('Отправка данных на сервер:', payload);
        await this.$store.dispatch('schedules/updateSchedule', payload);
        ElMessage.success('Смены успешно обновлены');
      } catch (error) {
        console.error('Ошибка при обновлении смен:', error);
        ElMessage.error('Ошибка при обновлении смен');
      }
    },
    async onDeleteShifts(user) {
      try {
        await ElMessageBox.confirm(
          `Удалить все смены для сотрудника ${user.name}?`,
          'Подтверждение удаления',
          {
            confirmButtonText: 'Удалить',
            cancelButtonText: 'Отмена',
            type: 'warning'
          }
        );
        await this.deleteSchedule({
          user_id: user.id,
          city_id: user.city_id,
          branch_id: user.branch_id,
          room_id: user.room_id
        });
        ElMessage.success('Смены успешно удалены');
        this.loadSchedules();
      } catch {
        ElMessage.info('Удаление отменено');
      }
    }
  }
}
</script>



<style scoped>
.scheduler-page {
  padding: 20px;
}

.create-shift-btn {
  margin-top: 20px;
}

.tabs {
  margin-bottom: 20px;
}
</style>
